export const getLayerConstraints = (layer) => ({
  horizontal: layer.constraints.horizontal,
  vertical: layer.constraints.vertical,
});
